import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ isAuthenticated, redirectPath = '/admin/login' }) => {
    if (!isAuthenticated) {
        return <Navigate to={redirectPath} replace />;
    }
    return <Outlet />;
};

export const AdminProtectedRoute = () => {
    const isAdminAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true';
    return <ProtectedRoute isAuthenticated={isAdminAuthenticated} redirectPath="/admin/login" />;
};

export default ProtectedRoute;